module.exports = __webpack_public_path__ + "img/Avatar-50.1a1240b6.svg";